import { Formik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "./form-fields/Button";
import DropdownField from "./form-fields/DropdownField";

import { getSpecialities } from "../../redux/slice/form-field/formFieldSlice";
import { getSearchProviders } from "../../redux/slice/provider-search/searchProvidersSlice";
import { setLocalStorageItem } from "../../service/utils";
import { t } from "i18next";

const RefineProviderNetworkSearchForm = ({ providerData, setProviderData }) => {
  const initialValues = {
    specialitySearch: providerData.specialitySearch
      ? providerData.specialitySearch
      : "",
  };
  const dispatch = useDispatch();
  const { specialitiesData } = useSelector((state) => state.formField);

  useEffect(() => {
    dispatch(getSpecialities());
  }, []);

  return (
    <div className="col-md-3 argusnetwork-search padding-none">
      <div className="col-md-12 sideheading">
        <i className="bars-icon" aria-hidden="true"></i>
        {t("refine-your-search")}

      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          const payload = {
            isDownloadPdf: false,
            delta: 10,
            pageNumber: 1,
            sortDirection: 1,
            specialitySearch: values.specialitySearch,
            isSpecialitySearch: true,
          };

          dispatch(getSearchProviders(payload));
          setLocalStorageItem("searchValues", {
            ...payload,
          });
        }}
        enableReinitialize
      >
        {({ values, handleSubmit, handleChange }) => (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="col-md-12 argusnetwork-form">
                <DropdownField
                  name="specialitySearch"
                  placeHolder={t("speciality-placeholder")}
                  options={specialitiesData}
                  value={values.specialitySearch}
                  onChange={(event) => {
                    handleChange(event);
                    setProviderData({
                      ...providerData,
                      specialitySearch: event.target.value,
                    });
                  }}
                />
              </div>

              <div className="span9 btn-block argusnetwork-form">
                <Button
                  isIcon={false}
                 buttonText={t("search-button")}
                  buttonType={"submit"}
                  className={"btn btn-large btn-block btn-search"}
                />
              </div>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default RefineProviderNetworkSearchForm;
